/**
 * Price, quantity and amount are three views of two facts.
 *
 * Invoices state whichever two the shop felt like: LCSC prints a unit price,
 * a local shop writes the line total, and both expect the third to follow.
 * Making somebody divide by hand is how a price ends up rounded wrong.
 */

/** Reads a typed number, taking a comma as the decimal separator — the comma is
 *  what a Russian keyboard layout and a Russian invoice both produce. */
export const num = (text: string): number | null => {
  const cleaned = text.replace(',', '.').trim();
  if (!cleaned) return null;
  const value = Number(cleaned);
  return Number.isFinite(value) ? value : null;
};

/** Formats a computed figure without trailing zeros. Four decimals because that
 *  is what the column holds; anything beyond it would be a number the server
 *  cannot store and the user cannot see. */
export const money = (value: number): string => String(Number(value.toFixed(4)));

/** The amount a line comes to, or an empty string when it cannot be known. */
export const amountOf = (quantity: string, price: string): string => {
  const q = num(quantity);
  const p = num(price);
  return q !== null && p !== null ? money(q * p) : '';
};

/** The unit price implied by an amount. Undefined at zero quantity rather than
 *  infinite: "5 rubles for nothing" has no unit price. */
export const priceOf = (quantity: string, amount: string): string => {
  const q = num(quantity);
  const a = num(amount);
  return q !== null && q !== 0 && a !== null ? money(a / q) : '';
};
